import { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import useToast from '../../../../hooks/useToast';
import LoaderContext from '../../../../context/LoaderProvider';
import { workReportLineStatus } from '../../../../utils/dataStatus';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';
import { formatFullDate, formatsEnum } from '../../../../utils/formatUtils';
import { useDetailServiceRequest } from '../../../../context/DetailServiceRequestProvider';
import { postLocationProgramPointService } from '../../../../services/programPointsService';

const STATES_TO_EXCLUDE = [
  workReportLineStatus.enviar,
  workReportLineStatus.aprobar,
  workReportLineStatus.fijar
];

const SendToApproveAllLines = ({
  disabledByRol,
  selectedDate,
  workReportLines,
  newFetch,
  setNewFetch
}) => {
  const selectedDateFormated = new Date(selectedDate);
  const today = new Date();
  const todayOlderThanSelectedDate = today < selectedDateFormated;
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const { updateDetailsforAssignedStatus } = useDetailServiceRequest();

  const fetchToApproveALine = async (lineToApprove) => {
    setLoader(true);
    try {
      const resp = await postLocationProgramPointService(lineToApprove);

      setNewFetch(!newFetch);
      setLoader(false);
      updateDetailsforAssignedStatus();
      setNewToast({
        type: 'SUCCESS',
        message: resp.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error?.data?.message || error?.mensaje
      });
    }
  };

  const dataAdapter = workReportLines
    ?.filter(
      (line) =>
        !STATES_TO_EXCLUDE.includes(line.estadoEnum) &&
        line.cantidad !== null &&
        line.cantidad !== '0' &&
        line.cantidad !== 0 &&
        !line.bloqueadoEnSap &&
        line.habilitaNotificacion &&
        new Date(formatFullDate(line.fecha, formatsEnum.FORMAT_DATE_2)) < today
    )
    .map((line) => ({
      id: line.idParteDiario,
      cantidad: parseFloat(line.cantidad)
    }));

  // const linesAfterToday = workReportLines
  //   ?.filter((line) => {
  //     const dateOfLine = new Date(formatFullDate(line.fecha, formatsEnum.FORMAT_DATE_2));
  //     const lineAfterToday = dateOfLine >= today;
  //     const correctState =
  //       !STATES_TO_EXCLUDE.includes(line.estadoEnum) &&
  //       line.cantidad !== null &&
  //       line.cantidad !== '0';

  //     return false;
  //   })
  //   .map((line) => ({
  //     id: line.idParteDiario,
  //     cantidad: Number(line.cantidad)
  //   }));

  return (
    <div className="d-flex justify-content-end mt-4">
      <ConditionalWrapper
        condition={todayOlderThanSelectedDate}
        wrapper={(children) => (
          <OverlayTrigger
            delay={{
              show: 250,
              hide: 400
            }}
            overlay={
              <Tooltip id="button-aprove-all-sds">Linea con fecha posterior a la actual</Tooltip>
            }
            placement="left"
          >
            {children}
          </OverlayTrigger>
        )}
      >
        <div>
          <Button
            className="px-3"
            disabled={disabledByRol || !dataAdapter.length}
            label="Enviar a aprobar"
            onClick={() => {
              fetchToApproveALine(dataAdapter);
            }}
            type="button"
            variant="primary"
            widthButton="150px"
          />
        </div>
      </ConditionalWrapper>
    </div>
  );
};

SendToApproveAllLines.propTypes = {
  disabledByRol: PropTypes.bool.isRequired,
  newFetch: PropTypes.bool,
  selectedDate: PropTypes.string.isRequired,
  setNewFetch: PropTypes.func,
  workReportLines: PropTypes.arrayOf(
    PropTypes.shape({
      idParteDiario: PropTypes.number,
      cantidad: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired
};

SendToApproveAllLines.defaultProps = {
  newFetch: false,
  setNewFetch: () => {}
};

export default SendToApproveAllLines;
